<section class="home-hero" *ngIf="activeSlide as slide" aria-label="Painel principal">
  <div class="home-hero__content">
    <div class="home-hero__text">
      <span class="home-hero__badge">{{ slide.badge }}</span>
      <h1 class="home-hero__title">{{ slide.title }}</h1>
      <p class="home-hero__description">{{ slide.description }}</p>
    </div>

    <div class="home-hero__stats" aria-label="Indicadores">
      <article
        class="home-hero__stat"
        *ngFor="let stat of slide.stats; trackBy: trackStat">
        <p class="home-hero__stat-label">{{ stat.label }}</p>
        <p class="home-hero__stat-value">
          <span class="home-hero__stat-number">{{ stat.value }}</span>
          <span class="home-hero__stat-unit">{{ stat.unit }}</span>
        </p>
      </article>
    </div>
  </div>

  <div class="home-hero__dots" *ngIf="showDots" role="tablist" aria-label="Navegação do painel principal">
    <button
      *ngFor="let slideItem of slides; let index = index; trackBy: trackSlide"
      type="button"
      class="home-hero__dot"
      [class.home-hero__dot--active]="index === activeSlideIndex"
      role="tab"
      [attr.aria-selected]="index === activeSlideIndex"
      [attr.aria-label]="'Painel ' + (index + 1)"
      (click)="selectSlide(index)">
    </button>
  </div>
</section>
